import Form from "../components/form";

const Assessment = () => {

     return (
          <div className="assessment">
               <h1>Book a free assessment.</h1>
               <p>Want to know your child’s current level?
                    We host frequent assessments to see their level and also to advise parents on next moves depending on their goals. Our assessment includes maths, English, verbal reasoning and non verbal reasoning.</p>
               <Form formId="Assessment" />
          </div>
     );
};

export default Assessment;